export default function buildQuerystring(
  options: {[key: string]: any} = {},
  queryOptions: string[] = [],
): string {

  let querystring = ''
  let pairs: string[] = []

  queryOptions.forEach((optionName) => {
    if (optionName in options) {
      pairs.push(optionName + '=' + encodeURIComponent(options[optionName]))
    }
  })

  if (pairs.length > 0) {
    querystring = '?' + pairs.join('&')
  }

  return querystring

}
